import { gql } from "../__generated__/gql";

gql(`
    fragment AddressFields on Address {
        formatted
        route
        streetNumber
        longitude
        latitude
        locality {
            name
            postalCode
            state {
                name
                code
                country {
                    name
                    code
                }
            }
        }
    }
`);

gql(`
    fragment PersonFields on Person {
        id
        gender
        firstName
        lastName
        birthdate
        avsNumber
        monthlySalary
    }
`);

gql(`
    fragment WorkerProfileFields on WorkerProfile {
        __typename
        id
        avsNumber
        educationLevel
        yearsOfExperience
        maritalStatus
        maritalStatusFrom
        hasOtherActivity
        partner {
            ...PersonFields
        }
        hasChildren
        children {
            ...PersonFields    
        }
        hasFiscalAttestation
        lppRegistrations {
            fund {
                ...LPPFundFields
            }
            registrationFormData
        }
        bankAccount {
            id
            name
            iban
        }
        workPermit
        documents {
            id
            type
            title
            documentUrl
            asset {
                ...AssetFields
            }
       }
       relationshipCount
    }
`);

gql(`
    fragment ClientProfileFields on ClientProfile {
        __typename
        id
        businessEmail
        client {
            id
            name
            uid
            status
            rejectedReason
            address {
                ...AddressFields
            }
            hoursPerWeekFullTime
            logoUrl
            ijmGroup {
                ...IjmGroupField
            }
            ijmPayFirstDays
            ijmPayRemainingPercents
            canChangeIjmGroup
        }
        clientRelationshipCount
        isPrivateClient
    }
`);

gql(`
    fragment ClientInfoFields on ClientInfo {
        id
        name
        uid
        profileName
        phoneNumber
        email
        isPrivateClient
        avatarUrl
        logoUrl
        verified
        address {
            ...AddressFields
        }
        hoursPerWeekFullTime
        deleted
    }
`);

gql(`
    fragment WorkerInfoFields on WorkerInfo {
        id
        gender
        avatarUrl
        email
        name
        phoneNumber
        birthdate
        deleted
        workPermitStatus
    }
`);

gql(`
    fragment WorkerInfoWithMissionsFields on WorkerInfo {
        id
        gender
        avatarUrl
        email
        name
        phoneNumber
        birthdate
        educationLevel
        yearsOfExperience
        deleted
        workPermitStatus
        documents {
            id
            type
            title
            documentUrl
        }
        missionCount {
            total
            draft
            pendingAcceptation
            accepted
            ended
            terminated
            cancelled
        }
        address {
            ...AddressFields
        }
    }
`);

gql(`
    fragment UserFields on User {
        id
        email
        phoneNumber
        verified
        firstName
        lastName
        birthdate
        workPermit
        age
        gender
        avatarUrl
        expoPushToken
        firebasePushToken
        intercomUserId
        iosIntercomHmac
        androidIntercomHmac
        webIntercomHmac
        kycStatus {
            status
            reason
            veriffUrl
        }
        avatarUrl
        workerProfile {
            ...WorkerProfileFields
        }
        clientProfiles {
            ...ClientProfileFields
        }
        workerInfo {
            ...WorkerInfoFields
        }
        clientInfos {
            ...ClientInfoFields
        }
        address {
            ...AddressFields
        }
        nationality
    }
`);

export const GET_USER = gql(`
    query CurrentUser {
        currentUser {
            ...UserFields
        }
    }
`);

export const GET_DEFAULT_PROFILE_TYPE = gql(`
    query GetDefaultProfileType {
        getDefaultProfileType
    }
`);

export const UPDATE_PUSH_TOKEN = gql(`
    mutation UpdatePushToken($expoPushToken: String, $firebasePushToken: String) {
        updateUser(
            userData: { expoPushToken: $expoPushToken, firebasePushToken: $firebasePushToken }
        ) {
            id
        }
    }
`);

export const UPDATE_USER = gql(`
    mutation UpdateUser($userData: UserInput!) {
        updateUser(userData: $userData) {
            ...UserFields
        }
    }
`);

export const DELETE_USER = gql(`
    mutation DeleteUser {
        deleteUser
    }
`);

export const DELETE_CURRENT_PROFILE = gql(`
    mutation DeleteCurrentProfile {
        deleteCurrentProfile
    }
`);

export const END_VERIFF_SESSION = gql(`
    mutation EndVeriffSession {
        verificationSubmitted
    }
`);

export const VERIFICATION_RESET = gql(`
    mutation VerificationReset {
        verificationReset
    }
`);
